import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { getErrorResponse } from 'utils/xhr';
import { previewCatalogPreviewQuery as catalogPreviewQuery } from 'api/CatalogAPI';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { CatalogPreviewRequestAction, CatalogPreviewResponsePayload } from './types';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { errorIds } from '../errorIds';

export function* getCatalogPreviewsSaga({ catalogName, searchQuery }: CatalogPreviewRequestAction) {
  try {
    const response: CatalogPreviewResponsePayload = yield call(
      catalogPreviewQuery,
      catalogName,
      searchQuery,
    );
    yield put(actions.catalogPreviewQueryResponse(response.data.results));
  } catch (e) {
    const error = getErrorResponse(e);
    yield put(actions.catalogPreviewQueryError(error));
    addNegativeToastWithErrorId('Error previewing catalog query', errorIds.catalogPreview.get, e);
  }
}

addToRootSaga([takeLatest(actionTypes.CATALOG_PREVIEW_REQUEST, getCatalogPreviewsSaga)]);
